import { Suspense } from 'react';
import routes from './Routes';
import { Routes, Route } from 'react-router-dom';

const Layout = () => {
    return (
        <main className='main'>
            <Suspense fallback={<div>Cargando...</div>}>
                <Routes>
                    {routes.map((route, idx) => {
                        const Component = route.element;

                        return (
                            <Route
                                key={idx}
                                path={route.path}
                                element={<Component />}
                            />
                        );
                    })}
                </Routes>
            </Suspense>
        </main>
    )
}

export default Layout
